import {
  Badge,
  Box,
  Paper,
  Stack,
  styled,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import { CustomTabPanel } from "../../../shared";
import arrowIcon from "../../../assets/images/Icons/Vector (9).svg";
import { BatchesView, OtherRecipes } from "../components";
import emptyIcon from "../../../assets/images/Icons/search-table.png";
import { formatWeightWithUnits } from "../../../utils";
import { PcAndTemplateProductFilterHeader } from "../../../shared/components/PcAndTemplateProductFilterHeader";
import { Fragment, useState } from "react";

const StyledBadge = styled(Badge)(({ active }) => ({
  "& .MuiBadge-badge": {
    right: 4,
    top: 10,
    padding: "0 4px",
    position: "relative",
    background: active ? "#FFFFFF" : "#263141",
    color: active ? "#263141" : "#FFFFFF",
  },
}));

export const CommonBatchTabs = ({
  templateDetails,
  templates,
  handleBatchClick,
  handleRecipeClick,
  setTemplates,
  globalData,
  value,
  setValue,
}) => {
  const [checked, setChecked] = useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setTemplates((draft) => {
      draft.indexColumn = 0;
    });
  };

  const onAllProductFilterChange = (value) => {
    // Set value
    setChecked(value);

    // Check whether selected item show in chart item
    const isShowInChartItemSelected = templates.selectedRecipe?.show_in_chart;

    // // reselect the item
    if (!value && !isShowInChartItemSelected) {
      const otherRecipes = templateDetails?.data?.other_recipes;
      let i = 0;
      for (const category of otherRecipes) {
        const recipe = category.recipes?.find((r) => r.show_in_chart);
        if (recipe) {
          return handleRecipeClick(recipe, i);
        }
        i++;
      }
    }
  };

  // Function filter the products
  const filterProducts = (products = [], showInChart) => {
    return products.filter((product) => showInChart || product.show_in_chart);
  };

  const getTotalRecipes = (recipes = [], reduce = false) => {
    return reduce
      ? recipes.reduce((acc, option) => option.recipes.length + acc, 0)
      : recipes.length;
  };

  const batchesLength = templateDetails?.data?.batches?.length || 0;

  const isCategoryBasedOtherRecipes =
    templateDetails?.data?.other_recipes?.length > 0 &&
    Array.isArray(templateDetails?.data?.other_recipes[0]?.recipes);

  const recipesLength = getTotalRecipes(
    templateDetails?.data?.other_recipes,
    isCategoryBasedOtherRecipes,
  );

  return (
    <Stack
      sx={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
      }}
    >
      {/* Action Grid */}
      <Stack
        // p="8px"
        sx={{
          backgroundColor: "#F2F7FC",
          width: { md: value === 0 ? "290px" : "331px", xs: "100%" },
          transition: "width 0.5s",
          height: "calc(100dvh - 145px)",
          overflowY: "auto",
        }}
      >
        <Box
          sx={{
            p: "8px",
            backgroundColor: "neutral.98",
          }}
        >
          <Tabs
            className="styled-tabs"
            value={value}
            onChange={handleChange}
            sx={{
              marginLeft: "0",
            }}
          >
            <Tab
              label={
                <Stack direction="row" gap="10px">
                  Batches
                  <StyledBadge
                    badgeContent={batchesLength}
                    active={value === 0}
                  />
                </Stack>
              }
            />
            <Tab
              label={
                <Stack direction="row" gap="10px">
                  Products
                  <StyledBadge
                    badgeContent={recipesLength}
                    active={value === 1}
                  />
                </Stack>
              }
            />
          </Tabs>
        </Box>

        {/* Batches */}
        {value === 0 && (
          <Box px="8px">
            <Stack height="34px" justifyContent="center">
              <Typography fontWeight={600} fontSize="12px">
                Recipe Name
              </Typography>
            </Stack>

            {templateDetails?.data?.batches?.length ? (
              <Box
                component={Paper}
                sx={{
                  borderRadius: "4px",
                  overflow: "hidden",
                  border: 1,
                  borderColor: "divider",
                }}
              >
                {templateDetails?.data?.batches?.map((item, index) => {
                  const isSelected = index === templates.indexColumn;
                  const lastItem = templateDetails?.data?.batches.length - 1;
                  return (
                    <Stack
                      sx={{
                        minHeight: "30px",
                        color: isSelected ? "#FFFFFF" : "text.primary",
                        backgroundColor: isSelected
                          ? "primary.main"
                          : "#FFFFFF",
                        borderBottom: lastItem === index ? 0 : 1,
                        borderColor: "divider",
                        padding: "8px 12px",
                        cursor: "pointer",
                      }}
                      onClick={() => handleBatchClick(item, index)}
                    >
                      <Stack
                        direction="row"
                        justifyContent="space-between"
                        flexWrap="wrap"
                        alignItems={"center"}
                      >
                        <Stack
                          alignItems="flex-start"
                          maxWidth="calc(100% - 12px)"
                        >
                          <Typography
                            fontWeight={500}
                            fontSize="14px"
                            alignContent="center"
                            sx={{
                              overflowWrap: "break-word",
                              wordBreak: "break-word",
                              whiteSpace: "normal",
                            }}
                          >
                            {item?.recipe_name}
                          </Typography>
                          <Typography fontSize="12px" fontWeight={500}>
                            {formatWeightWithUnits(
                              item?.total_weight,
                              item?.total_weight_unit,
                              globalData?.all_Units,
                            )}
                          </Typography>
                        </Stack>
                        <img
                          alt="details"
                          src={arrowIcon}
                          style={{
                            height: "10px",
                          }}
                        />
                      </Stack>
                    </Stack>
                  );
                })}
              </Box>
            ) : (
              <Stack
                alignItems="center"
                gap="8px"
                justifyContent="center"
                height="calc(100dvh - 245px)"
              >
                <img src={emptyIcon} alt="empty" height={40} width={40} />
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontSize: "14px",
                    color: "#485364",
                  }}
                >
                  There are no batches yet!
                </Typography>
              </Stack>
            )}
          </Box>
        )}

        {/* Products */}
        {value === 1 && (
          <Fragment>
            <PcAndTemplateProductFilterHeader
              checked={checked}
              setChecked={onAllProductFilterChange}
              isCategory={isCategoryBasedOtherRecipes}
            />
            {isCategoryBasedOtherRecipes ? (
              templateDetails?.data?.other_recipes?.map((item, index) => {
                return (
                  <CategoryProductList
                    key={index}
                    category={item}
                    checked={checked}
                    state={templates}
                    onRecipeSelect={handleRecipeClick}
                    globalData={globalData}
                    filterProducts={filterProducts}
                  />
                );
              })
            ) : (
              <Box mx="8px" border={1} borderColor="divider" borderRadius="8px">
                <DefaultProductList
                  state={templates}
                  globalData={globalData}
                  onRecipeSelect={handleRecipeClick}
                  data={templateDetails?.data?.other_recipes}
                />
              </Box>
            )}
          </Fragment>
        )}
      </Stack>

      {/* View Grid */}
      <Box
        flex={1}
        sx={{
          backgroundColor: "#FFFFFF",
        }}
      >
        <CustomTabPanel
          value={value}
          index={0}
          border={false}
          style={{
            minHeight: "calc(100dvh - 145px)",
          }}
        >
          <BatchesView
            selectedOptionBatch={templates.selectedBatch}
            templates={templates}
            globalData={globalData}
          />
        </CustomTabPanel>
        <CustomTabPanel
          value={value}
          index={1}
          border={false}
          style={{
            height: "calc(100dvh - 145px)",
            paddingInline: "12px",
            paddingBottom: "12px",
            overflowY: "auto",
          }}
        >
          <OtherRecipes
            selectedOptionRecipe={templates.selectedRecipe}
            globalData={globalData}
          />
        </CustomTabPanel>
      </Box>
    </Stack>
  );
};

const DefaultProductList = ({
  data = [],
  globalData,
  state,
  onRecipeSelect,
}) => {
  const selectedItem = state?.selectedRecipe;

  return data.map((item, index) => {
    const isSelected = item.recipe_id === selectedItem?.recipe_id;

    const lastItem = data.length - 1;
    return (
      <Stack
        sx={{
          minHeight: "30px",
          color: isSelected ? "#FFFFFF" : "#263141",
          backgroundColor: isSelected ? "primary.main" : "#FFFFFF",
          cursor: "pointer",
          borderBottom: lastItem === index ? 0 : 1,
          borderColor: "divider",
          padding: "8px 12px",
        }}
        onClick={() => onRecipeSelect(item, index)}
      >
        <Stack direction="row" justifyContent="space-between">
          <Typography
            fontWeight={400}
            fontSize="14px"
            alignContent="center"
            sx={{
              overflowWrap: "break-word",
              wordBreak: "break-word",
              whiteSpace: "normal",
            }}
          >
            {item?.recipe_name}
          </Typography>
          <Stack direction="row" gap="8px" alignItems="center" flexShrink={0}>
            <Typography fontSize="14px" fontWeight={500}>
              {formatWeightWithUnits(
                item?.total_quantity,
                item?.selling_unit_name,
                globalData?.all_Units,
              )}
            </Typography>
            <img
              alt="details"
              src={arrowIcon}
              style={{
                height: "10px",
              }}
            />
          </Stack>
        </Stack>
      </Stack>
    );
  });
};

const CategoryProductList = ({
  checked,
  category,
  globalData,
  state,
  filterProducts,
  onRecipeSelect,
}) => {
  const isCategoryUnknown = category.id < 1;
  const filteredProducts = filterProducts(category.recipes, checked);

  return filteredProducts.length > 0 ? (
    <Box p="8px" key={category.id}>
      <Typography
        p="8px"
        color="gray"
        fontSize={12}
        fontWeight={400}
        display={isCategoryUnknown ? "none" : ""}
      >
        {category.category_name}
      </Typography>

      <DefaultProductList
        state={state}
        data={filteredProducts}
        globalData={globalData}
        onRecipeSelect={onRecipeSelect}
      />
    </Box>
  ) : (
    <></>
  );
};
